import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Filter, X } from 'lucide-react';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { useContractorFilter, AVAILABLE_CONTRACTORS } from '../contexts/ContractorFilterContext';
export function FilterBanner() {
  const {
    selectedProjects,
    setSelectedProjects
  } = useProjectFilter();
  const {
    selectedContractors,
    setSelectedContractors
  } = useContractorFilter();
  const allProjectsSelected = selectedProjects.length === AVAILABLE_PROJECTS.length;
  const allContractorsSelected = selectedContractors.length === AVAILABLE_CONTRACTORS.length;
  const hasActiveFilters = !allProjectsSelected || !allContractorsSelected;
  const handleClearFilters = () => {
    setSelectedProjects(AVAILABLE_PROJECTS);
    setSelectedContractors(AVAILABLE_CONTRACTORS);
  };
  const getFilterText = () => {
    const parts = [];
    if (!allProjectsSelected) {
      parts.push(`${selectedProjects.length} of ${AVAILABLE_PROJECTS.length} sites`);
    }
    if (!allContractorsSelected) {
      parts.push(`${selectedContractors.length} of ${AVAILABLE_CONTRACTORS.length} contractors`);
    }
    return `Showing data for ${parts.join(' and ')}`;
  };
  return <AnimatePresence data-id="element-593" data-mp="2jm1o7t0kil1b">
      {hasActiveFilters && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="overflow-hidden" data-id="element-594" data-mp="2jki6rz36e3xy">
          <div className="bg-amber-100 border border-amber-300 rounded-lg px-4 py-2.5 mb-2" data-id="element-595" data-mp="20tr1p9q80zpd">
            <div className="flex items-center justify-between" data-id="element-596" data-mp="1mwu9p4yd9c6w">
              <div className="flex items-center gap-2 text-sm text-amber-900" data-id="element-597" data-mp="1ru3wsdya9brk">
                <Filter size={16} className="text-amber-600" data-id="element-598" data-mp="3tkuq1428geuf" />
                <span className="font-semibold" data-id="element-599" data-mp="3tme2ejkrq5qx">{getFilterText()}</span>
              </div>
              <button onClick={handleClearFilters} className="flex items-center gap-1.5 text-xs font-semibold text-amber-800 hover:text-amber-950 bg-amber-200 hover:bg-amber-300 px-2.5 py-1.5 rounded-md transition-colors" data-id="element-600" data-mp="3ori0mrpqc40m">
                <X size={14} data-id="element-601" data-mp="gchv5q1e447i" />
                Clear filters
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}